// extracted by mini-css-extract-plugin
export default {"top-info-wrapper":"styles_top-info-wrapper__cDTsD","text":"styles_text__9Zsdr"};